import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Init",
    component: () => import("@/views/Init.vue"),
  },
  {
    path: "/campaign",
    name: "Campaign",
    component: () => import("@/views/Campaign.vue"),
  },
  {
    path: "/expired",
    name: "Expired",
    component: () => import("@/views/Expired.vue"),
  },
  {
    path: "/systemError",
    name: "SystemError",
    component: () => import("@/views/SystemError.vue"),
  },
  {
    path: "/addFriend",
    name: "AddFriend",
    component: () => import("@/views/AddFriend.vue"),
  },
  {
    path: "/myPage",
    name: "MyPage",
    component: () => import("@/views/MyPage.vue"),
  },
  {
    path: "/collabcourses",
    name: "CollabCourses",
    component: () => import("@/views/CollabCourses.vue"),
  },
  {
    path: "/linecourses",
    name: "LineCourses",
    component: () => import("@/views/LineCourses.vue"),
  },
  {
    path: "/request_detail",
    name: "RequestDetail",
    component: () => import("@/views/RequestDetail.vue"),
  },
  {
    path: "/result",
    name: "Result",
    component: () => import("@/views/Result.vue"),
    props: true,
  },
  {
    path: "/requestHistory",
    name: "RequestHistory",
    component: () => import("@/views/RequestHistory.vue"),
  },
  {
    path: "/collectionHistory",
    name: "CollectionHistory",
    component: () => import("@/views/CollectionHistory.vue"),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
